import React from "react";
import {Grid } from "@mui/material";
import "../styles/dashboard.styles.css";
import DashboardSidebar from "../components/DashboardSidebar";
import DashboardCards from "../components/DashboardCards";
function Dashboard() {
  return (
    <div>
      <Grid container justifyContent={"center"}>
        <Grid item lg={11.5}>
          <Grid container>
            <Grid item lg={1}>
              <DashboardSidebar/>
            </Grid>
            
            <Grid item lg={11} sx={{mt:{xs:2,md:3}}}>
            <DashboardCards />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Dashboard;
